module.exports = __webpack_public_path__ + "media/components/star-rating/static/white/0-c4ff7a88a24e89b46be4c8ae5134ee64.svg";